import { Injectable } from "@angular/core"
import { BybitWebsocketClient } from "../../../market"
import { Observable } from "rxjs"
import { Deal, Funding, OrderSide } from "../../../model/trade"
import { isWsExecutionEventV5 } from "libs/bybit-api/src"
import { parseFloatSafe } from "src/app/core/func"

@Injectable({
  providedIn: 'root'
})
export class BybitDealHandler {

  listen(ws: BybitWebsocketClient) {
    return new Observable<{deal: Deal} | {funding: Funding}>(subscriber => {
      const f = (data: any) => {
        // Проверяем, что это сообщение сделки и только category == 'linear'
        if (isWsExecutionEventV5(data)) {
          data.data.filter(row => row.category == 'linear').forEach(row => {
            if (row.execType == 'Funding') {
              const funding: Funding = {
                timestamp: data.creationTime,
                market: 'bybit',
                board: 'linear',
                symbol: row.symbol,
                fee: row.execFee,
              }
              subscriber.next({funding})
            }
            else {
              const deal: Deal = {
                timestamp: data.creationTime,
                market: 'bybit',
                board: 'linear',
                symbol: row.symbol,
                price: row.execPrice,
                quantity: row.execQty,
                volume: parseFloatSafe(row.execPrice) * parseFloatSafe(row.execQty),
                fee: row.execFee,
                side: row.side == 'Buy' ? OrderSide.buy : OrderSide.sell,
                dealId: row.execId,
                orderId: row.orderId,
                clientOrderId: row.orderLinkId,
              }
              subscriber.next({deal})
            }
          })
        }
      }

      ws.on('update', f)
      return () => ws.off('update', f)
    })
  }

}
